import { Component, OnInit } from '@angular/core';
import { DataService } from './services/data/data.service';
import { WebsocketsService } from './services/websockets/websockets.service';
import { TranslateService } from '@ngx-translate/core';
import { KeyboardShortcutsService } from './services/keyboard-shortcuts/keyboard-shortcuts.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private keyboard: KeyboardShortcutsService,
    private translate: TranslateService
  ) {
    translate.setDefaultLang('en');
    // translate.use('en');
  }
  version = '0.0.2';

  ngOnInit(): void {
    // this.wss.authenticateUser();
    // this.connect();
  }

  switchLanguage(lang: string) {
    this.translate.use(lang);
  }

  // connect() {
  //   this.wss.connect();
  // }

  // ngOnDestroy() {
  //   this.wss.disconnect();
  // }
}
